import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Box, Typography, useMediaQuery } from '@mui/material';
import LogosListGatsby from '../../../shared/LogoListGatsby/LogosListGatsby';
import Section from '../../../shared/Section/Section';
import styles from './styles';

const AI_IMAGES = ['gigachat', 'deepseek', 'chatgpt'];
const AI_MODELS = ['DeepSeek-R1', 'GigaChat', 'GPT-4', 'Copilot'];

const Checkbox = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17.208 0H6.804C2.736 0 0 2.856 0 7.104V16.908C0 21.144 2.736 24 6.804 24H17.208C21.276 24 24 21.144 24 16.908V7.104C24 2.856 21.276 0 17.208 0Z"
        fill="#29EDFF"
      />
      <path
        d="M11.2224 16.1254C10.9536 16.1254 10.6848 16.0174 10.4796 15.8003L7.63202 12.7864C7.22162 12.3521 7.22162 11.6485 7.63202 11.2154C8.04242 10.781 8.70602 10.7798 9.11642 11.2141L11.2224 13.443L16.176 8.20028C16.5864 7.76592 17.25 7.76592 17.6604 8.20028C18.0708 8.63464 18.0708 9.33824 17.6604 9.7726L11.9652 15.8003C11.76 16.0174 11.4912 16.1254 11.2224 16.1254Z"
        fill="#4520AB"
      />
    </svg>
  );
};

function StudyTools({ title, folder, list, logosData }) {
  const isJs = folder === 'js';
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const isMd = useMediaQuery((theme) => theme.breakpoints.down('md'));

  return (
    <Section title={title.first} subtitle={title.second} withoutBg>
      <Box sx={styles.wrapper}>
        <Box sx={isJs && !isMd ? styles.container : {}}>
          <LogosListGatsby
            list={list}
            logosData={logosData}
            path={`studyTools/${folder}`}
            aiSection={isJs}
          />
        </Box>
        {isJs && (
          <Box sx={[styles.aiSection, styles.container]}>
            <Box sx={styles.aiLogosWrapper}>
              {AI_IMAGES.map((img) => (
                <GatsbyImage
                  imgStyle={styles.image}
                  image={getImage(logosData[`studyTools/ai/${img}`])}
                  alt=""
                  loading="lazy"
                />
              ))}
            </Box>
            <Box sx={styles.modelsWrapper}>
              <Typography
                component="div"
                variant={isSm ? 'mobileP1' : 'desktopH4'}
                color="kit.text.h"
              >
                Модели для веб-разработки
              </Typography>
              {AI_MODELS.map((model) => (
                <Box sx={styles.model}>
                  <Checkbox />
                  <Typography variant="mobileP2">{model}</Typography>
                </Box>
              ))}
            </Box>
          </Box>
        )}
      </Box>
    </Section>
  );
}

export default StudyTools;
